import { HStack, Text } from "@chakra-ui/react";

const ReportPresentationSummary = ({ items }) => {
  if (!items?.length) return null;

  return (
    <HStack
      alignItems="center"
      bg="#f8fafc"
      borderLeft="4px solid #94a3b8"
      gap="10px"
      mb="28px"
      px="10px"
      py="6px"
      flexWrap="wrap"
    >
      <Text fontSize="12px" color="gray.600" fontWeight="700" textTransform="uppercase">
        Presentation
      </Text>
      <Text as="span" color="#374151" fontSize="12px" fontWeight="700">
        {items.join(" / ")}
      </Text>
    </HStack>
  );
};

export default ReportPresentationSummary;
